export const filterActions = {
  SORT: "SORT",
  TOGGLE_OUT_OF_STOCK: "TOGGLE_OUT_OF_STOCK",
  SET_CATEGORY: "SET_CATEGORY",
  SET_RATING: "SET_RATING",
  SET_PRICE_RANGE: "SET_PRICE_RANGE",
  SET_SEARCH_QUERY: "SER_SEARCH_QUERY",
   CLEAR: "CLEAR",
};
export const authActions = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
};
export const wishListActions = {
  ADD: "ADD_TO_WISHLIST",
  REMOVE: "REMOVE_FROM_WISHLIST",
};
export const cartActions = {
  ADD: "ADD_TO_CART",
  RESET: "RESET",
  REMOVE: "REMOVE_FROM_CART",
  INCREMENT: "INCREASE_QUANTITY",
  DECREMENT: "DECREASE_QUANTITY",
};

export const addressActions = {
  ADD_ADDRESS:"ADD_ADDRESS",
  SET_DEFAULT:"SET_DEFAULT"
}
export const ordersActions = {
  SET_ORDERS:"SET_ORDERS"
}